import React, { useEffect, useState } from "react"
import { makeKey } from "../../utils/Utils";
import { Container, Draggable } from 'react-smooth-dnd';
import { TrashIcon, PlusIcon } from "../../admin/Icons";
import wrap from "../../utils/wrap"
import { HolderOutlined } from '@ant-design/icons';
import RichTextEditor from "./RichTextEditor";
import { Checkbox, Collapse, Button, Divider, Input, Space } from "antd";



export default function Faqs(props) {

    const {
        setData = () => { },
        data = {},
        container = true,
        extra = false,
        paragraph_preset = 0,
        link_id = 0,
    } = props;

    const [faq, setFaq] = useState(props.faq.map(item => {
        return { ...item, "id": makeKey() }
    }))

    const [selected, setSelected] = useState("");

    const save = () => {
        setData({ ...data, "faq": faq});
    }

    useEffect(save, [faq])

    const updatePanel = (_key, _value, _index) => {
        let _arr = [...faq];
        _arr[_index][_key] = _value;
        setFaq(_arr);
    }

    const removePanel = (_index) => {
        let _arr = [...faq];
        _arr.splice(_index, 1);
        setFaq(_arr);
        setSelected("");
    }

    const addPanel = () => {
        let _arr = [...faq];
        _arr.push({
            label: 'Unnamed',
            headline: 'Headline',
            paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit.'
        })
        setSelected(_arr.length - 1);
        setFaq(_arr);
    }

    const drawFaq = (_faq = {}, _index) => {

        return (
            <div key={_index}>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">NAME</Divider>
                <Input style={{ "fontSize": "11px"}} placeholder="Name..." defaultValue={_faq.label} onBlur={(e) => updatePanel("label", e.target.value, _index)} />
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                <Input style={{ "fontSize": "11px"}} placeholder="Headline..." defaultValue={_faq.headline} onBlur={(e) => updatePanel("headline", e.target.value, _index)} />
                <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                <RichTextEditor container={container} link_id={link_id} paragraph_preset={paragraph_preset} background_colour_default="#fff" onFinish={(e) => updatePanel("paragraph", e, _index)} hold value={_faq.paragraph} />
                <div className="shim" />
            </div>
        )

    }

    const ExpandDiv = (props) => {
        const { id = "", title = "", extra = "" } = props;
        const [expanded, setExpanded] = useState(id === selected);

        return (
            <div>
                <div className="float-flex">
                    <div onClick={() => setSelected((id === selected) ? "" : id)} style={{ "cursor": "pointer" }}><Space>{(expanded) ? "-" : "+"}{title}</Space></div>
                    <div>{extra}</div>                
                </div>

                <div className="shim" />
                {(expanded && <div>{props.children}</div>)}
            </div>
        )
    }

    const drawFaqs = () => {
        return faq.map((item, index) => {
            return (
                <Draggable key={item.id}>
                    <Space>
                        <div style={{ "cursor": "pointer"}} className="img_drag_handle">
                            {((selected !== item.id) && <HolderOutlined style={{ "fontSize": "14px", "opacity": "0.5" }} />)} 
                        </div>
                        <div style={{ "width": (selected === item.id) ? "237px" : "223px"}}>
                            <ExpandDiv
                                id={item.id}
                                title={<><div style={{ "lineHeight": "10px"}}><wrap.tags small color="#e77e21">{(item.label) ? item.label : "Unnamed"} </wrap.tags></div></>}
                                extra={<><div style={{ "marginTop": "-2px" }}><Button onClick={() => removePanel(index)} type="link" icon={<TrashIcon />} size="small" /></div></>}    
                            >
                                {drawFaq(item, index)}
                            </ExpandDiv>
                        </div>
                    </Space>
                </Draggable>
            )
        })
    } 

    const onDrop = (dropResult) => {
        if (!dropResult.removedIndex && dropResult.removedIndex !== 0) return;

        const newItems = [...faq];
        newItems.splice(dropResult.addedIndex, 0, newItems.splice(dropResult.removedIndex, 1)[0]);
        console.log(newItems)
        setFaq(newItems);
    };

    return (
        <>
            <div className="float-flex">
                <div style={{ "width": "50px" }} orientationMargin={0} orientation="left" plain className="simple-divider ant-divider-with-text">FAQS</div>
                <div style={{ "marginTop": "-5px"}}><Button onClick={() => addPanel()} type="link" icon={<PlusIcon />} size="small" /></div>
            </div>
            <Divider style={{ "margin": "5px 0px "}} dashed />

            <Container
                dragHandleSelector=".img_drag_handle"
                lockAxis="y"
                onDrop={onDrop}
            >
                {drawFaqs()}
            </Container>
        </>
    )
}